import { SceneSetResponse } from '@bighealth/types';
import { APIRequestBody, APIResponse } from '../../types';
import { api } from '../../api';
import { AxiosRequestConfig } from 'axios';

export const transition_to_next_scene_set = async (
  args: transition_to_next_scene_set.Args,
  requestConfig?: AxiosRequestConfig
): Promise<transition_to_next_scene_set.Response> => {
  // Note: user_id and user_timezone are in the header
  const request: transition_to_next_scene_set.Request = {
    service_name: 'SceneSetGraph',
    service_version: '1',
    service_method: 'transition_to_next_scene_set',
    args,
  };

  return await api(request, requestConfig);
};

transition_to_next_scene_set.queryKey =
  'SceneSetGraph/transition_to_next_scene_set';

export declare namespace transition_to_next_scene_set {
  export type Args = {
    current_product_id: number;
    current_program_id: number;
    current_graph_id: number;
    current_scene_set_id?: number;
    enable_inter_graph_transitions?: boolean;
  };

  export interface Request extends APIRequestBody {
    service_name: 'SceneSetGraph';
    service_version: '1';
    service_method: 'transition_to_next_scene_set';
    args: Args;
  }

  export type Result = SceneSetResponse;

  export type Response = APIResponse<Result | null>;
}
